import script from "./BookingConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./BookingConfirmation.vue?vue&type=style&index=0&id=e0c2e6b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c2e6b6"]])

export default __exports__